<!-- 查询注册用户信息接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure.vue"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "userId": 3468,
                "phone": "18054103169",
                "pageNum": 1,
                "pageSize": 10
            },
            responseCode: {
                "data": {
                    "currCount": 1,
                    "recordList": [
                        {
                            "allowOtherPay": 1,
                            "autoPay": 1,
                            "autoPayLimit": 0,
                            "id": 3468,
                            "phone": "18054103169",
                            "pushAppMs": 1,
                            "pushWeixinMsg": 1,
                            "registerDate": "20180102225219",
                            "shareBalance": 0,
                            "status": 1,
                            "wechanList": [
                                {
                                    "appId": "123",
                                    "name": "公众号1"
                                }
                            ],
                            "wxAutoPay": 0
                        }
                    ],
                    "total": 1
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台,查询注册用户信息",
                t_url: this.commonUrls.test+"getUsers",
                p_url: this.commonUrls.prod+"getUsers",
                precondition: "无",
                fitSystem: "VEMS传统停车场，云停车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'userId', info2: '否', info3: 'Long', info4: '用户ID' },
                        { info1: 'phone', info2: '否', info3: 'String', info4: '手机号码' },
                        { info1: 'type', info2: '否', info3: 'Integer', info4: '用户类型，0游客 1会员。不填则全部' },
                        { info1: 'status', info2: '否', info3: 'Integer', info4: '用户状态，0冻结 1有效 2已注销。不填则全部' },
                        { info1: 'pageNum', info2: '是', info3: 'Integer', info4: '第几页，从1开始' },
                        { info1: 'pageSize', info2: '是', info3: 'Integer', info4: '每页多少条，最多1000条' }
                        ]
                },],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'total', info2: '是', info3: 'Integer', info4: '记录总数' },
                        { info1: 'currCount', info2: '是', info3: 'Integer', info4: '当前获取的记录数' },
                        { info1: 'recordList', info2: '是', info3: 'String', info4: '用户信息列表' },
                        ]
                },{
                    titleName: 'recordList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'id', info2: '是', info3: 'Long', info4: '用户ID' },
                        { info1: 'nickName', info2: '是', info3: 'String', info4: '用户呢称' },
                        { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
                        { info1: 'status', info2: '是', info3: 'Integer', info4: '账户状态 0冻结中 1有效 2已注销,注销后,只可重新注册' },
                        { info1: 'registerDate', info2: '是', info3: 'String', info4: '注册时间，yyyyMMddHHmmss' },
                        { info1: 'allowOtherPay', info2: '是', info3: 'Integer', info4: '是否允许他人代缴，1允许 0不允许' },
                        { info1: 'autoPay', info2: '是', info3: 'Integer', info4: '是否自动扣费，1是 0否' },
                        { info1: 'autoPayLimit', info2: '是', info3: 'Decimal', info4: '最大的扣费限额值' },
                        { info1: 'pushWeixinMsg', info2: '是', info3: 'Integer', info4: '是否推送微信消息，1推送 0不推送' },
                        { info1: 'pushAppMs', info2: '是', info3: 'Integer', info4: '是否推送app消息，1推送 0不推送' },
                        { info1: 'shareBalance', info2: '是', info3: 'String', info4: '共享车位收益金额' },
                        { info1: 'wxAutoPay', info2: '是', info3: 'Integer', info4: '是否免密自动扣费，0未开通 1已开通' },
                        { info1: 'wechatList', info2: '否', info3: 'JSONArray', info4: '用户微信公众号列表' },
                        ]
                },{
                    titleName: 'wechatList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'appId', info2: '是', info3: 'String', info4: '公众号appId' },
                        { info1: 'name', info2: '是', info3: 'String', info4: '公众号名称' },
                        ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/urbanOperation/ydtUser/getUsers.vue